<template>
<ViskaseCard>
    <template v-slot:title>
    </template>
    <template v-slot:default>
        <div class="row">
            <div class="col-12 col-sm-6">
                <div class="logo mx-5">
                    <img class="img-fluid" :src="selectedCasing.img" alt="Image" />
                </div>
                <div v-if="!selectedSolution.title">
                    <div class="m-1 p-1 fw-bold h3"><span class="viskase-orange-text fw-bold">{{selectedCasing.title}}</span>
                    </div>
                </div>
                <div v-if="selectedSolution.title">
                    <div class="m-1 p-1 fw-bold h3"> <span class="fw-bold">{{selectedSolution.title}}</span> {{made_with}} <span class="viskase-orange-text fw-bold">{{selectedCasing.title}}</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6">
                <div class="m-1 p-1 fw-bold h3">
                    {{request_contact}}
                </div>
                <div class="m-1 p-1">
                    <label class="form-label">{{name}}</label>
                    <input type="text" class="form-control" v-model="offerName">
                </div>
                <div class="m-1 p-1">
                    <label class="form-label">{{email}}</label>
                    <input type="email" class="form-control" v-model="offerEmail">
                </div>
                <div class="m-1 p-1">
                    <label class="form-label">{{company}}</label>
                    <input type="text" class="form-control" v-model="offerCompany">
                </div>
                <div class="m-1 p-1">
                    <label class="form-label">{{phone}}</label>
                    <input type="text" class="form-control" v-model="offerPhone">
                </div>
                <div class="m-1 p-1">
                    {{interested}}
                </div>
                <div class='row casing-selection'>
                    <div class="form-check col-6 col-xs-12 col-sm-6" v-for="(item, index) in offerCasings" :key="index">
                        <input class="form-check-input" type="checkbox" v-model="item.selected">
                        <label class="form-check-label capitalize" for="flexCheckChecked">
                            {{lowercase(item.title)}}
                        </label>
                    </div>
                </div>
                <div class="m-1 p-1 marketing pt-3"> 
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="agreeAll">
                        <label class="form-check-label" for="flexSwitchCheckDefault" v-html="accept_all"></label>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="agreeProcessing">
                        <label class="form-check-label" for="flexSwitchCheckDefault" v-html="accept_12months"></label>
                    </div>
                    <div class="intro-contact pt-1" v-html="intro_contact"></div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="agreePhone">
                        <label class="form-check-label" for="flexSwitchCheckDefault" v-html="accept_phone"></label>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="agreeEmail">
                        <label class="form-check-label" for="flexSwitchCheckDefault" v-html="accept_email"></label>
                    </div>
                    <div class="summary-contact pt-1" v-html="summary_contact"></div>
                    <div class="summary-policy" v-html="read_more_privacy_policy"></div>
                </div>
            </div>
        </div>
    </template>
</ViskaseCard>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ViskaseCard from "@/components/core/ViskaseCard.vue";
import ViskaseTile from "@/components/core/ViskaseTile.vue";
import { mapProperties } from "@/utilities/vuex";
export default {
  name: "ThankYou",
  components: {
    ViskaseCard,
    ViskaseTile,
  },
  mounted() {
    this.offerName = "";
    this.offerCompany = "";
    this.offerPhone = "";
    this.offerEmail = "";
    this.agreeAll = false;
    this.agreeProcessing = false;
    this.agreePhone = false;
    this.agreeEmail = false;
    for (const element of this.offerCasings) {
      if (element.name === this.selectedCasing.name) {
        element.selected = true;
      }
    }
  },

  data() {
    return {};
  },
  watch: {
    agreeAll() {
      if (this.agreeAll === true) {
        this.agreeProcessing = true;
        this.agreePhone = true;
        this.agreeEmail = true;
      }
    },
  },

  methods: {
    ...mapActions([]),
    ...mapMutations([]),
    lowercase(text) {
      //W css jest capitalize ;-)
      if (typeof text !== "string") return "";
      return text.toLowerCase();
    },
  },
  computed: {
    ...mapState([
      "casings",
      "selectedCasing",
      "selectedSolution",
      "offerCasings",
      "cards",
    ]),
    ...mapProperties([
      "offerName",
      "offerPhone",
      "offerCompany",
      "offerEmail",
      "agreeAll",
      "agreeProcessing",
      "agreePhone",
      "agreeEmail",
    ]),
    request_contact() {
      return this.cards.offerRequest.request_contact;
    },
    name() {
      return this.cards.offerRequest.name;
    },
    phone() {
      return this.cards.offerRequest.phone;
    },
    email() {
      return this.cards.offerRequest.email;
    },
    company() {
      return this.cards.offerRequest.company;
    },
    interested() {
      return this.cards.offerRequest.interested;
    },
    made_with() {
      return this.cards.offerRequest.made_with;
    },
    marketing_consents() {
      return this.cards.meeting.marketing_consents;
    },
    accept_all() {
      return this.cards.meeting.accept_all;
    },
    accept_12months() {
      return this.cards.meeting.accept_12months;
    },
    accept_phone() {
      return this.cards.meeting.accept_phone;
    },
    accept_email() {
      return this.cards.meeting.accept_email;
    },
    summary_contact() {
      return this.cards.meeting.summary_contact;
    },
    read_more_privacy_policy() {
      return this.cards.meeting.read_more_privacy_policy;
    },
  },
};
</script> 

<style scoped>
@media (min-width: 768px) {
  .casing-selection {
    padding-left: 2.8rem;
  }
}

@media (max-width: 767px) {
  .casing-selection {
    padding-left: 1.3rem;
  }
}

.marketing-consents,
.marketing label,
.intro-contact,
.summary-contact,
.summary-policy {
  font-size: 0.8rem;
}
</style>
